import gsap from 'gsap';
import { ease1 } from '../../easings';
import splittedText from '@/animations/splitted-text';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';

export function createInitialMainPageTimeline(container: HTMLElement | Document = document) {
    const mainTitle = container.querySelector<HTMLElement>('.js-main-initial-title');
    const splittedTextTween = mainTitle ? splittedText(mainTitle) : null;

    const videoTl = gsap.timeline({ defaults: { duration: 1.5, ease: ease1 } });
    videoTl.fromTo(container.querySelector('.js-main-initial-video-wrapper'), { opacity: 0 }, { opacity: 1 });

    const tl = gsap.timeline({ paused: true, defaults: { duration: 1, ease: ease1 } });

    tl.set('.js-main-initial-title', { opacity: 1 })
        .add(splittedTextTween ? splittedTextTween.play() : gsap.to({}, {}))
        .add(videoTl, 0.5)
        .fromTo('.js-main-first-section__text', { yPercent: 100, opacity: 0 }, { yPercent: 0, opacity: 1 }, 0.6)
        .fromTo(
            '.js-main-first-section__scrolldown-btn svg',
            { yPercent: 100, opacity: 0 },
            { yPercent: 0, opacity: 1 },
            0.75,
        );

    if (DEVICE_WIDTH.isDesktop) {
        tl.set('.c-scrollbar', { opacity: 1, delay: -0.4 });
    }

    return tl;
}
